// extracted by mini-css-extract-plugin
export default {"wrapper":"FormInput_wrapper__vhtw7","item-wp":"FormInput_item-wp__9rHQd","btn_submit":"FormInput_btn_submit__jFfEr"};